"use client";

import { useEffect } from "react";
import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk";
import {
  faroEnabled,
  faroRelease,
  faroSampleRate,
  faroUrl,
  isScriptario,
  publicAppEnv,
  siteId,
  siteLocale,
} from "@/lib/config";
import { scrubFaroItem, scrubUrl } from "@/lib/faro-scrub";

const IGNORED_URLS = [/\/api\/client-observability/i, /\/faro\/collect/i];

let initialized = false;

export function FaroObservability() {
  useEffect(() => {
    if (initialized || !faroEnabled || !faroUrl) return;
    initialized = true;

    initializeFaro({
      url: faroUrl,
      app: {
        name: isScriptario ? "scriptario-landing" : `${siteId}-landing`,
        version: faroRelease || "dev",
        release: faroRelease || "dev",
        environment: publicAppEnv || "production",
        namespace: siteId,
      },
      metas: [
        {
          page: {
            attributes: {
              surface: "landing",
              siteId,
              locale: siteLocale,
              market: siteId,
            },
          },
        },
      ],
      instrumentations: [...getWebInstrumentations()],
      ignoreUrls: IGNORED_URLS,
      sessionTracking: {
        enabled: true,
        samplingRate: faroSampleRate,
      },
      pageTracking: {
        page: {
          id: scrubUrl(window.location.pathname),
        },
      },
      beforeSend: (item) => scrubFaroItem(item),
    });
  }, []);

  return null;
}
